const UUID_PATTERN =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

export function getInstanceIdFromLocation(location: {
  pathname: string;
  search: string;
}) {
  const queryParams = new URLSearchParams(location.search);
  const fromQuery = queryParams.get("instanceId");
  if (fromQuery) {
    return fromQuery;
  }

  const pathParts = location.pathname.split("/").filter(Boolean);
  const fileName = decodeURIComponent(pathParts[pathParts.length - 1] ?? "");
  const fileMatch = fileName.match(
    new RegExp(`^gallery[._-](${UUID_PATTERN.source})\\.html$`, "i")
  );

  if (fileMatch?.[1]) {
    return fileMatch[1];
  }

  if (pathParts[0] === "gallery" && pathParts[1]) {
    return pathParts[1];
  }

  if (pathParts[0] === "render" && pathParts[1]) {
    return pathParts[1];
  }

  if (pathParts[0] === "designer" && pathParts[2] === "render") {
    return pathParts[1] ?? "";
  }

  if (fileName.toLowerCase().endsWith(".html")) {
    return "";
  }

  return pathParts[1] ?? "";
}
